// extracted by mini-css-extract-plugin
export var closed = "_as-1";
export var resizer = "_as-0";